export function isAndroid() {
    if (typeof window === 'undefined') {
        return false;
    }
    return navigator.userAgent.toLowerCase().indexOf('android') > -1;
}
//# sourceMappingURL=browser.js.map